export default __webpack_public_path__ + "static/media/arrow.ed2e4c91.svg";